// Bridges api-base's reload-required callback — fired inside the axios interceptor,
// outside React — to the tree via `useSyncExternalStore`. A one-way latch: once
// signalled it stays on, so re-firing is idempotent.

let required = false;
const listeners = new Set<() => void>();

export const reloadRequiredStore = {
    /** Signal that a reload is required; notifies subscribers once (idempotent). */
    trigger(): void {
        if (required) return;
        required = true;
        listeners.forEach((l) => l());
    },
    subscribe(listener: () => void): () => void {
        listeners.add(listener);
        return () => listeners.delete(listener);
    },
    getSnapshot(): boolean {
        return required;
    },
};
